import {
  Box,
  Button,
  Grid,
  Link,
  TextField,
  Typography,
  useMediaQuery,
  Card,
} from '@mui/material'
import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../redux/storeExports'
import {
  postFamilyStatus,
  selectFamilyStatus,
} from '@meprism/shared/src/redux/product/ProductSlice'

const styles = {
  header: {
    fontFamily: 'InterMedium',
    fontWeight: 500,
    lineHeight: '27px',
    color: "#3A155A",
    mb: '10px',
    fontSize: '20px',
  },
  paragraph: {
    fontFamily: 'InterRegular',
    fontWeight: 400, 
    fontSize: '14px',
    lineHeight: '21px',
    color: '#6B7280',
  },
  buttonTheme: {
    borderRadius: '10px',
    width: '100%',
    maxWidth: '200px',
    height: '50px',
    backgroundColor: '#9135E0',
    color: '#FFFFFF',
    fontFamily: 'InterRegular',
    fontWeight: 500,
    fontSize: '14px !important',
    lineHeight: '150%',
    letterSpacing: '2%',
    textAlign: 'center',
    '&:hover': {
        backgroundColor: '#9135E0',
    },
    '&.Mui-disabled': {
      background: '#fff',
      color: '#A0A0A4',
      border: '2px solid #A0A0A4',
      opacity: 0.7,
    }
  },
   InvitedButtonTheme: {
    borderRadius: '10px',
    width: '100%',
    maxWidth: '200px',
    height: '50px',
    backgroundColor: '#fff !important',
    color: '#ffc300',
    fontFamily: 'InterRegular',
    fontWeight: 500,
    fontSize: '14px !important',
    lineHeight: '150%',
    letterSpacing: '2%',
    textAlign: 'center',
    border: '2px solid #ffc300',
    '&:hover': {
        backgroundColor: '#fff',
    },
    '&.Mui-disabled': {
    backgroundColor: '#fff !important',
    color: '#ffc300',
    }
  },
  AcceptedButtonTheme: {
    borderRadius: '10px',
    width: '100%',
    maxWidth: '200px',
    height: '50px',
    backgroundColor: '#fff !important',
    color: '#2ecc71',
    fontFamily: 'InterRegular',
    fontWeight: 500,
    fontSize: '14px !important',
    lineHeight: '150%',
    letterSpacing: '2%',
    textAlign: 'center',
    border: '2px solid #2ecc71',
    '&:hover': {
        backgroundColor: '#fff',
    },
    '&.Mui-disabled': {
    backgroundColor: '#fff !important',
    color: '#2ecc71',
    }
  },
}

const PlusOne = () => {
  const dispatch = useAppDispatch()
  const isMobile = useMediaQuery('(max-width:600px)')
  const familyPlan = useAppSelector(selectFamilyStatus)
  const [mailAdded,setMailAdded] = useState(false)
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const handleSubscribe = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const maxChars = 100; // Maximum characters allowed for email

    if (email.length > maxChars) {
      setError('Email exceeds maximum of 100 character limit')
      return;
    }
    if (!emailRegex.test(email) ) {
      setError('Invalid email format')
      return
    }
    if (email !== '') {
      setMailAdded(true)
      try{
        await dispatch(postFamilyStatus(email)).unwrap()
      }catch(e){
        console.log("error sending family invite : ",e)
      }
    }
  }

  return (
    <Card
      sx={{
          py: !isMobile ? '30px' : 0,
          px: !isMobile ? '16px' : '2.5px',
          mb: isMobile ? 4: 9,
          mt: !isMobile ? 5 : 0,
          minHeight: '230px',
          borderRadius: '15px',
          boxShadow: isMobile ? 'none'  : '0px 6px 9.2px 0px #0000000A',
          flexDirection: isMobile ? 'column' : 'row'
      }}
  >
    <Box sx={{ flexDirection: isMobile ? 'column' : 'row' }}>
      {!isMobile && (
        <Typography sx={styles.header}>
          Plus One Management
        </Typography>
      )}
      <Box sx={{ marginBlock: '1rem' }}>
        <Typography sx={styles.paragraph}>
          Invite your plus one to your account. Once you have sent the invite,
          you cannot change this.{' '}
          <Link href="https://meprism1.atlassian.net/servicedesk/customer/portal/1" 
            sx={{
              fontSize: '14px !important',
              color: '#9135E0',
            }}
            >
            Contact mePrism support
          </Link>{' '}
          for further assistance.
        </Typography>
      </Box>
      {familyPlan.email ? (
        <Grid container columnSpacing={4} rowSpacing={4}>
          <Grid item md={8} xs={12}>
            <TextField
              disabled
              size="small"
              value={familyPlan.email}
                sx={{
                  width: '100%',
                  backgroundColor: '#FFF',
                  '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  width: '100%',
                  height: '50px',
                  backgroundColor: '#FFF', 
                  '& fieldset': {
                      border: '1.5px solid #A0A0A4 !important'
                  },
                  },
                  '& .MuiInputBase-input': {
                      color: '#A0A0A4',
                      paddingLeft: '20px',
                      fontFamily: 'InterRegular',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '140%',
                  }
                }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Button sx={
                  ['invited', 'queued'].includes(familyPlan.invite_status) || mailAdded 
                    ? styles.InvitedButtonTheme
                    : styles.AcceptedButtonTheme
                } disabled>
                {['invited', 'queued'].includes(familyPlan.invite_status) || mailAdded
                  ? 'Invited'
                  : familyPlan.invite_status.charAt(0).toUpperCase() +
                    familyPlan.invite_status.slice(1)}
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid container columnSpacing={4} rowSpacing={4}>
          <Grid item md={8} xs={12}>
            <TextField
              size="small"
              error={!!error}
              helperText={error ?? ''}
              onChange={(e) => {
                setEmail(e.target.value)}
              }
              placeholder="Enter email..."
                sx={{
                  width: '100%',
                  backgroundColor: '#FFF',
                  '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  width: '100%',
                  height: '50px',
                  backgroundColor: '#FFF', 
                  '& fieldset': {
                      border: '1.5px solid #9135E0 !important'
                  },
                  },
                  '& .MuiInputBase-input': {
                      color: '#3A155A',
                      paddingLeft: '20px',
                      fontFamily: 'InterRegular',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '140%',
                  },
                }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Button sx={styles.buttonTheme} onClick={handleSubscribe}>
                Send Invite
            </Button>
          </Grid>
        </Grid>
      )}
    </Box>
    </Card>
  )
}

export default PlusOne
